import { gql } from '@apollo/client';
import { maybeRestErrorMessage } from 'modules/campaigns/editor/utils';
import { DEFAULT_RESPONSE_ERROR_MESSAGE } from 'modules/campaigns/lib/constants';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';
import { CampaignAlertsWebhook } from '../types';

export const getWebhookQuery = gql`
  query campaignAlertsWebhook($id: Long!) {
    campaignAlertsWebhook(id: $id) {
      id
      createdAt
      updatedAt
      projectId
      name
      enabled
      endpoint
      authType
      authToken
      clientId
      clientSecret
      tokenEndpoint
    }
  }
`;

type UseGetWebHookResponse = {
  campaignAlertsWebhook: CampaignAlertsWebhook;
};

export const useGetWebhook = (id: number | undefined) => {
  const dispatch = useDispatch();

  const {
    data,
    isLoading,
    errorMessage: error,
    refetch,
  } = useGraphql<UseGetWebHookResponse>(getWebhookQuery, {
    variables: { id },
    onError: (e) => {
      const errorResponseMessage = maybeRestErrorMessage(e) || DEFAULT_RESPONSE_ERROR_MESSAGE;
      const errorMessage = `Cannot fetch webhook ID ${id}: ${errorResponseMessage}`;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'useGetWebhook', e));
    },
  });

  return {
    webhook: data?.campaignAlertsWebhook ?? ({} as CampaignAlertsWebhook),
    loading: isLoading,
    errorMessage: error?.message || (data?.campaignAlertsWebhook as any)?.failure?.message,
    refetch,
  };
};
